<div class="row gy-3 justify-content-between align-items-center mt-1">
    <div class="col-12 col-sm-auto">
        <div class="group">
            <button
                *ngFor="let option of periods"
                class="btn btn-sm secondary"
                role="option"
                [class.active]="(period$ | async).name === option.name"
                [attr.aria-selected]="(period$ | async).name === option.name || null"
                (click)="setPeriod(option)"
            >
                {{ option.name }}
            </button>
        </div>
    </div>
</div>
<div class="overflow-x-auto">
    <angular-generic-table
        [data]="data$ | async"
        [config]="tableConfig$ | async"
        [loading]="loading$"
        style="margin-bottom: 2px"
        class="d-block"
    >
        <div class="table-loading skeleton-loader skeleton-loader-table"></div>
        <div class="table-no-data alert alert-info mt-3">Table is empty</div>
    </angular-generic-table>
</div>

<!-- FORMATTED AMOUNT TEMPLATE -->
<ng-template
    #formattedAmount
    let-row="row"
    let-col="col"
    let-index="index"
    let-data="data"
>
    <span
        [matTooltip]="row[col.key] | formatCurrency$: row.ccy | async"
        [matTooltipPosition]="'above'"
    >
        {{ row[col.key] | formatCurrency$: null:'0.0a' | async }}
        <ng-container *ngIf="index > 0">
            <gt-delta [index]="index" [data]="data" [key]="col.key"></gt-delta>
        </ng-container>
    </span>
</ng-template>

<!-- FORMATTED VALUE TEMPLATE -->
<ng-template
    #formattedNumber
    let-row="row"
    let-col="col"
    let-index="index"
    let-data="data"
>
    <span
        [matTooltip]="row[col.key] | formattedNumber$ | async"
        [matTooltipPosition]="'above'"
    >
        {{ row[col.key] | formattedNumber$ | async }}
        <ng-container *ngIf="index > 0">
            <gt-delta [index]="index" [data]="data" [key]="col.key"></gt-delta>
        </ng-container>
    </span>
</ng-template>

<!-- FORMATTED PERCENT TEMPLATE -->
<ng-template #formattedPercent let-row="row" let-col="col" let-index="index">
    {{ row[col.key] | formattedPercent$ | async }}
</ng-template>
